import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { parseFoodItemWithGroup } from "../../pos/newpos/helpers";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

//context consumer
import { UserContext } from "../../../../../contexts/User";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";


const KotCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    adminStaffForSearch,
  } = useContext(UserContext);

  let {
    //dept-tag
    getKOT,
    KOTList,
    setKOTList,
    setPaginatedKOT,
    KOTForSearch,
    setKOTForSearch,

    branchForSearch,

    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  const { 
    //common
    loading,
    setLoading,
    //food
    foodForPOS,
    propertyItemForSearch,
    foodGroupForPOSById
  } = useContext(FoodContext);
  // console.log("check food==>",foodForPOS,foodForSearch)
  // States hook here
  //new dept-tag
  let [newKOT, setNewKOT] = useState({
    name: "",
    printer_name: "",
    printer_ip: "",
    groups: null,
    user: "",
    edit: false,
    editSlug: null,
    uploading: false,
    branch_id: null,
    branch_name: null,
  });

  //search result
  let [searchedKOT, setSearchedKOT] = useState({
    list: null,
    searched: false,
  });

  let [item, setitem] = useState([]);
  let [propertyItem, setPropertyItem] = useState([]);
  let [branch, setBranch] = useState(null);
  const [groups, setGroups] = useState([]);

  useEffect(()=>{
    if(foodForPOS){
      const foodItemGrp = parseFoodItemWithGroup(foodForPOS,foodGroupForPOSById);
      setGroups(Object.values(foodItemGrp))
    }
  },[foodForPOS])

  //set name hook
  const handleSetNewKOT = (e) => {
    setNewKOT({ ...newKOT, [e.target.name]: e.target.value });
  };

  //Save New kot
  const handleSaveNewKOT = (e) => {
    e.preventDefault();
    if (branch !== null && item !== null && item.length > 0) {

    setNewKOT({
      ...newKOT,
      uploading: true,
    });

    const foodGroupUrl = BASE_URL + `/settings/new-kot`;
    let formData = new FormData();
    formData.append("name", newKOT.name);
    formData.append("printer_name", newKOT.printer_name);
    formData.append("printer_ip", newKOT.printer_ip);
    formData.append("branch_name", newKOT.branch_name);
    formData.append("branch_id", newKOT.branch_id);
    formData.append("user_id", newKOT.user?.id ?? "");

    let tempArray = [];
    item.map((Item) => {
      tempArray.push(Item.id);
    });
    formData.append("item_id", tempArray);

    let tempArrayProperty = [];
    propertyItem && propertyItem.map((Item) => {
      tempArrayProperty.push(Item.id);
    });
    formData.append("property_item_id", tempArrayProperty);

    return axios
      .post(foodGroupUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewKOT({
          name: "",
          user: "",
          printer_name: "",
          printer_ip: "",
          groups: null,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setitem([]);
        setPropertyItem([]);
        setBranch(null);
        setKOTList(res.data[0]);
        setKOTForSearch(res.data[1]);
        setSearchedKOT({
          ...searchedKOT,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("KOT has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewKOT({
          ...newKOT,
          uploading: false,
        });
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A KOT already exists with this name") {
                toast.error(`${_t(t("A KOT already exists with this name"))}`, {
                  position: "bottom-center",
                  autoClose: 10000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  className: "text-center toast-notification",
                });
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
    }else{
      toast.error(`${_t(t("All Fields are Required"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //set edit true & values or duplicate
  const handleSetEdit = (slug, duplicate= null) => {
    const hasDuplicate = duplicate && duplicate === "?duplicate=1";
    let kotItems = KOTForSearch.find((item) => {
      return item.slug === slug;
    });
   
    // let selectOptionsProprttyGroup = [];
    // let selectOptionsPropertyItem = [];
  
    const propertyArray = JSON.parse(kotItems.item_id);
    const propertyItemArray = JSON.parse(kotItems.property_item_id);
    
      // for (var i = 0; i < foodForPOS?.length; i++) {
      //   if (propertyArray.includes(foodForPOS[i].id)) {
      //     selectOptionsProprttyGroup.push(foodForPOS[i]);
      //   }
      // }
      const selectOptionsItems = propertyArray?.length ? foodForPOS?.filter(item => propertyArray.includes(item.id)) : [];
      setitem(selectOptionsItems);
    

      // for (var i = 0; i < propertyItemForSearch.length; i++) {
      //   if (propertyItemArray.includes(propertyItemForSearch[i].id)) {
      //     selectOptionsPropertyItem.push(propertyItemForSearch[i]);
      //   }
      // }
      const selectOptionsPropertyItem = propertyItemArray?.length ? propertyItemForSearch?.filter(item => propertyItemArray.includes(item.id)) : [];
      setPropertyItem(selectOptionsPropertyItem);
   

    // if (branchArray.length !== 0) {
    //   for (var property of branchArray) {
    //     for (var i = 0; i < branchForSearch.length; i++) {
    //       if (branchForSearch[i].id == property) {
    //         selectOptionsBranch.push(branchForSearch[i]);
    //       }
    //     }
    //     setBranch(selectOptionsBranch);
    //   }
    // } else {
    //   setBranch([]);
    // }

    const branch_id = parseInt(kotItems.branch_id);
    if (branch_id) {
      let selectedBranch = branchForSearch.find((item) => {
        return item.id === branch_id;
      });
      setBranch(selectedBranch);
    }
    let user = "";
    if(kotItems?.user_id){
      user = adminStaffForSearch.find((item) => {
        return item.id === kotItems.user_id
      })
    }

    setNewKOT({
      ...newKOT,
      name: kotItems.name,
      user: user,
      printer_name: kotItems.printer_name,
      printer_ip: kotItems.printer_ip,
      input_key: kotItems.input_key,
      editSlug: hasDuplicate ? null : kotItems.slug,
      branch_id: kotItems.branch_id,
      branch_name: kotItems.branch_name,
      edit: hasDuplicate ? false : true,
    });
  };
  

  //update food group
  const handleUpdateKOT = (e) => {
    e.preventDefault();
    if (branch !== null && item !== null && item.length > 0) {

    setNewKOT({
      ...newKOT,
      uploading: true,
    });
    const foodGroupUrl = BASE_URL + `/settings/update-kot`;
    let formData = new FormData();
    formData.append("name", newKOT.name);
    formData.append("printer_name", newKOT.printer_name);
    formData.append("printer_ip", newKOT.printer_ip);
    formData.append("editSlug", newKOT.editSlug);
    // formData.append("branch_id", newKOT.branch_id);
    formData.append("branch_name", newKOT.branch_name);

    // for Branch Multi
    // let tempbranch = [];
    // branch.map((Item) => {
    //   tempbranch.push(Item.id);
    // });
    formData.append("branch_id", newKOT.branch_id);
    formData.append("user_id", newKOT.user?.id ?? "");
    //for Associate_with
    let tempArray = [];
    item.map((Item) => {
      tempArray.push(Item.id);
    });
    formData.append("item_id", tempArray);

    let tempArrayProperty = [];
    propertyItem && propertyItem.map((Item) => {
      tempArrayProperty.push(Item.id);
    });
    formData.append("property_item_id", tempArrayProperty);

    return axios
      .post(foodGroupUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewKOT({
          name: "",
          user: "",
          printer_name: "",
          printer_ip: "",
          groups: null,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setitem([]);
        setBranch(null);
        setKOTList(res.data[0]);
        setKOTForSearch(res.data[1]);
        setSearchedKOT({
          ...searchedKOT,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("KOT has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewKOT({
          ...newKOT,
          uploading: false,
        });
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A KOT already exists with this name") {
                toast.error(`${_t(t("A KOT already exists with this name"))}`, {
                  position: "bottom-center",
                  autoClose: 10000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  className: "text-center toast-notification",
                });
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
    }else{
      toast.error(`${_t(t("All Fields are Required"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //search food group here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedKOT({ ...searchedKOT, searched: false });
    } else {
      let searchedList = KOTForSearch.filter((item) => {
        let lowerCaseItemName = item.name.toLowerCase();
        return lowerCaseItemName.includes(searchInput);
      });
      setSearchedKOT({
        ...searchedKOT,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of kot
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteKOT(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete kot here
  const handleDeleteKOT = (slug) => {
    setLoading(true);
    const foodGroupUrl = BASE_URL + `/settings/delete-kot/${slug}`;
    return axios
      .get(foodGroupUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setKOTList(res.data[0]);
        setKOTForSearch(res.data[1]);
        setSearchedKOT({
          ...searchedKOT,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("KOT has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const handleSetGroup=(group)=>{
    setNewKOT((curr)=>({
      ...curr,
      groups: group
    }))
  }

  const handleAddNew = (e) =>{
    e.stopPropagation();
    if( newKOT.groups?.length){
      const itms = newKOT.groups.flatMap((item)=>item.items);
      setitem(itms);
    }
  }

  const handleAppend = (e) =>{
    e.stopPropagation();
    if( newKOT.groups?.length){
      const itms = newKOT.groups.flatMap((item)=>item.items);
      const appendItems = [...itms, ...item]
      setitem(appendItems);
    }
  }

  const handleSetItem = (accosiateOption) => {
    // console.log("accosiateOption", accosiateOption);
    // setNewParty({ ...newParty, accosiateOption });
    setitem(accosiateOption);
  };

  const handleSetPropertyItem = (accosiateOption) => {
    // console.log("accosiateOption", accosiateOption);
    // setNewParty({ ...newParty, accosiateOption });
    setPropertyItem(accosiateOption);
  };
  console.log("first",newKOT)
  const handleSetUser = (user)=>{
    setNewKOT({
      ...newKOT,
      user
    })
  }

  const handleSetBranch = (branch) => {
    // console.log("branch", branch);
    setNewKOT({
      ...newKOT,
      branch_id: branch.id,
      branch_name: branch.name,
    });
    setBranch(branch);
  };

  // const handleDefaultMenu = (menu_id) => {
  //   setDefaultMenu(menu_id);

  //   const foodGroupUrl = BASE_URL + `/settings/update-default-menu`;

  //   let formData = new FormData();

  //   formData.append("id", menu_id);

  //   return axios
  //     .post(foodGroupUrl, formData, {
  //       headers: { Authorization: `Bearer ${getCookie()}` },
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       toast.success(
  //         `${_t(t("The menu has been set successfully on by default"))}`,
  //         {
  //           position: "bottom-center",
  //           autoClose: 10000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           className: "text-center toast-notification",
  //         }
  //       );
  //     });
  // };

  return (
    <>
      <Helmet>
        <title>{_t(t("KOT"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addPaymentType" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newKOT.edit ? _t(t("Add new Kot")) : _t(t("Update Kot"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newKOT.uploading === false ? (
                <div key="fragment-dept-tag-1">
                  <form
                    onSubmit={!newKOT.edit ? handleSaveNewKOT : handleUpdateKOT}
                    autoComplete="off"
                  >
                    <div>
                      <label htmlFor="name" className="form-label">
                        {_t(t("Kot Name"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="e.g. BBQ, Bar, Kitchen etc"
                        value={newKOT.name || ""}
                        required
                        onChange={handleSetNewKOT}
                      />
                    </div>
                    
                    <div className="mt-3 row">
                      <div className="col-10">
                        <label htmlFor="associate" className="form-label">
                          {_t(t("Group"))}
                        </label>
                        <Select
                          options={groups}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti={true}
                          closeMenuOnSelect={false}
                          maxMenuHeight="200px"
                          onChange={handleSetGroup}
                          placeholder={_t(t("Please select item")) + ".."}
                        />
                      </div>
                      <div className="col-2" style={{marginTop:"1.85rem"}}>
                        <button type="button" className="btn btn-primary rounded-sm w-100" onClick={(e)=>handleAddNew(e)}>Add New</button>
                      </div>
                      {/* <div className="col-3" style={{marginTop:"1.85rem"}}>
                        <button type="button" className="btn btn-success rounded-sm w-100"  onClick={(e)=>handleAppend(e)}>Append In Old</button>
                      </div> */}
                    </div>

                    <div className="mt-3">
                      <label htmlFor="associate" className="form-label">
                        {_t(t("Items"))}
                        <small className="text-danger">*</small>
                      </label>
                      <Select
                        value={item}
                        options={foodForPOS}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isMulti={true}
                        closeMenuOnSelect={false}
                        maxMenuHeight="200px"
                        onChange={handleSetItem}
                        placeholder={_t(t("Please select item")) + ".."}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="associate" className="form-label">
                        {_t(t("Property Items"))}
                      </label>
                      <Select
                        value={propertyItem}
                        options={propertyItemForSearch && propertyItemForSearch.filter((item)=>item.status === 1)}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isMulti={true}
                        closeMenuOnSelect={false}
                        maxMenuHeight="200px"
                        onChange={handleSetPropertyItem}
                        placeholder={_t(t("Please select item")) + ".."}
                      />
                    </div>

                    <div className="row">
                      <div className="mt-3 col-6">
                        <label htmlFor="branch" className="form-label">
                          {_t(t("Branch"))}
                          <small className="text-danger">*</small>
                        </label>
                        <Select
                          value={branch}
                          options={branchForSearch}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          className="basic-select"
                          classNamePrefix="select"
                          maxMenuHeight="200px"
                          onChange={handleSetBranch}
                          placeholder={_t(t("Please select branch")) + ".."}
                        />
                      </div>
                      <div className="mt-3 col-6">
                        <label htmlFor="user" className="form-label">
                          {_t(t("User"))}
                        </label>
                        <Select
                          value={newKOT?.user ?? null}
                          options={adminStaffForSearch}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          className="basic-select"
                          classNamePrefix="select"
                          isClearable
                          maxMenuHeight="200px"
                          onChange={handleSetUser}
                          placeholder={_t(t("Please select user")) + ".."}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="mt-3 col-6">
                        <label htmlFor="printer_name" className="form-label">
                          {_t(t("Printer Name"))}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="printer_name"
                          name="printer_name"
                          min="0"
                          placeholder="e.g printer_name"
                          value={newKOT.printer_name || ""}
                          required
                          onChange={handleSetNewKOT}
                        />
                      </div>

                      <div className="mt-3 col-6">
                        <label htmlFor="printer_ip" className="form-label">
                          {_t(t("Printer IP"))}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="printer_ip"
                          name="printer_ip"
                          min="0"
                          placeholder="e.g printer_ip"
                          value={newKOT.printer_ip || ""}
                          required
                          onChange={handleSetNewKOT}
                        />
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end align-items-center">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newKOT.edit ? _t(t("Save")) : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end align-items-center">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newKOT.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newKOT.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        <CustomSpinLoader loading={loading || dataPaginating}/>
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchedKOT.searched
                                    ? _t(t("KOT List"))
                                    : _t(t("Search Result"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              {/* Search group */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary rounded-right"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add group modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <button
                                  type="button"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                  data-toggle="modal"
                                  data-target="#addPaymentType"
                                  onClick={() => {
                                    setNewKOT({
                                      ...newKOT,
                                      edit: false,
                                      uploading: false,
                                      name: "",
                                      printer_name: "",
                                      printer_ip: "", 
                                      groups: null,                                     
                                      editSlug: "",                                      
                                      branch_id: "",
                                      branch_name: "",
                                    });
                                    setitem(null);
                                    setBranch(null);
                                    setPropertyItem(null);
                                  }}
                                >
                                  {_t(t("add new"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table */}
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover min-table-height">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Name"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Branch"))}
                                </th>
                                <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Printer Ip"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Action"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                              {!searchedKOT.searched
                                ? [
                                    KOTList && [
                                      KOTList.data.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        KOTList.data.map((item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index +
                                                  1 +
                                                  (KOTList.current_page - 1) *
                                                    KOTList.per_page}
                                              </th>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.name}
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.branch_name}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.printer_ip}
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {/* <div className="dropdown"> */}
                                                  {/* <button
                                                    className="btn t-bg-clear t-text-dark--light-40"
                                                    type="button"
                                                    data-toggle="dropdown"
                                                  >
                                                    <i className="fa fa-ellipsis-h"></i>
                                                  </button> */}
                                                  {/* <div className="dropdown-menu"> */}
                                                    {/* <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() =>
                                                        handleSetEdit(item.slug)
                                                      }
                                                      data-toggle="modal"
                                                      data-target="#addPaymentType"
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-pencil"></i>
                                                      </span>
                                                      {_t(t("Edit"))}
                                                    </button> */}

                                                    {/* <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() => {
                                                        handleDeleteConfirmation(
                                                          item.slug
                                                        );
                                                      }}
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-trash"></i>
                                                      </span>
                                                      {_t(t("Delete"))}
                                                    </button> */}
                                                  {/* </div> */}
                                                {/* </div> */}
                                                <button
                                                  className="btn btn-primary ml-2 rounded-sm del-btn"
                                                  onClick={() =>
                                                    handleSetEdit(item.slug)
                                                  }
                                                  data-toggle="modal"
                                                  data-target="#addPaymentType"                                                   
                                                  >                                                    
                                                    <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
                                                 </button>
                                                  
                                                  <button
                                                    title="duplicate kot"
                                                    className="btn btn-success ml-2 rounded-sm del-btn"
                                                    onClick={()=> handleSetEdit(item.slug,"?duplicate=1")}
                                                    data-toggle="modal"
                                                    data-target="#addPaymentType" 
                                                  >
                                                    <i className="fa fa-clone"></i>  
                                                  </button>
                                              </td>
                                            </tr>
                                          );
                                        })
                                      ),
                                    ],
                                  ]
                                : [
                                    /* searched data, logic === haveData*/
                                    searchedKOT && [
                                      searchedKOT.list.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        searchedKOT.list.map((item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index +
                                                  1 +
                                                  (KOTList.current_page - 1) *
                                                    KOTList.per_page}
                                              </th>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.name}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.branch_name}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.printer_ip}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {/* <div className="dropdown">
                                                  <button
                                                    className="btn t-bg-clear t-text-dark--light-40"
                                                    type="button"
                                                    data-toggle="dropdown"
                                                  >
                                                    <i className="fa fa-ellipsis-h"></i>
                                                  </button>
                                                  <div className="dropdown-menu">
                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() =>
                                                        handleSetEdit(item.slug)
                                                      }
                                                      data-toggle="modal"
                                                      data-target="#addPaymentType"
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-pencil"></i>
                                                      </span>
                                                      {_t(t("Edit"))}
                                                    </button>

                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() => {
                                                        handleDeleteConfirmation(
                                                          item.slug
                                                        );
                                                      }}
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-trash"></i>
                                                      </span>
                                                      {_t(t("Delete"))}
                                                    </button>
                                                  </div>
                                                </div> */}
                                                <button
                                                  className="btn btn-primary ml-2 rounded-sm del-btn"
                                                  onClick={() =>
                                                    handleSetEdit(item.slug)
                                                  }
                                                  data-toggle="modal"
                                                  data-target="#addPaymentType"                                                   
                                                  >                                                    
                                                    <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
                                                 </button>
                                                 <button
                                                    title="duplicate kot"
                                                    className="btn btn-success ml-2 rounded-sm del-btn"
                                                    onClick={()=> handleSetEdit(item.slug,"?duplicate=1")}
                                                    data-toggle="modal"
                                                    data-target="#addPaymentType" 
                                                  >
                                                    <i className="fa fa-clone"></i>  
                                                  </button>
                                              </td>
                                            </tr>
                                          );
                                        })
                                      ),
                                    ],
                                  ]}
                            </tbody>
                          </table>
                        </div>
                      </div>                    
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {newKOT.uploading === true || loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedKOT.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(KOTList, setPaginatedKOT)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(KOTList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchedKOT({
                                      ...searchedKOT,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedKOT,
                                    KOTForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default KotCrud;
